import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';

export default function RcsCheckbox(props) {
  const { checked = false, setChecked, productIndex } = props;
  const onChange = () => {
    setChecked(!checked);
  };

  return (
    <Checkbox
      data-e2e="rcs-select-product"
      label={`Select product ${productIndex}`}
      shouldHideLabel
      checked={checked}
      onChange={onChange}
    />
  );
}

RcsCheckbox.defaultProps = {
  setChecked: () => {},
};

RcsCheckbox.propTypes = {
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  productIndex: PropTypes.string,
};
